// CANDLE.AI logo — stylized candlestick with AI flame on top
export const Logo = ({ className = "h-7 w-7", color = "#00FF88" }) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    {/* Flame (AI spark) */}
    <path
      d="M16 1.5 C 17 4 19 5 18.6 7.5 C 18.4 8.5 17.6 9 17 9 C 17.5 8 17 6.8 16 6.5 C 16.2 7.6 15.5 8.4 14.8 8.6 C 13.6 9 13 8 13.2 7 C 13.5 5.5 15 4.5 16 1.5 Z"
      fill={color}
    />
    {/* Upper wick */}
    <line x1="16" y1="9.5" x2="16" y2="12.5" stroke={color} strokeWidth="1.6" strokeLinecap="square" />
    {/* Body */}
    <rect x="10.5" y="12.5" width="11" height="13" fill={color} stroke={color} strokeWidth="1.2" />
    {/* Inner highlight */}
    <rect x="13" y="15" width="6" height="8" fill="#001a0d" opacity="0.55" />
    {/* Lower wick */}
    <line x1="16" y1="25.5" x2="16" y2="29" stroke={color} strokeWidth="1.6" strokeLinecap="square" />
  </svg>
);

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <span className={`relative inline-flex items-center justify-center ${className} border border-bull/40 bg-bull/10`}>
    <Logo className="h-4 w-4" />
  </span>
);

export const BrandLockup = () => (
  <div className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-mono text-[13px] tracking-[0.22em] uppercase text-white">
      CANDLE<span className="text-bull">.</span>AI
    </span>
  </div>
);
